import React from 'react'
import { Pressable, Text, View } from 'react-native'
import {
  BG_STYLES,
  BUTTON_STATUS,
  BottomDrawer,
  Button,
  BUTTON_TYPE,
  COLORS,
  COMMON_STYLES,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
} from '@dehaat/dds'
import BouncyCheckbox from 'react-native-bouncy-checkbox'
import OutlinedInput from 'app/components/priceRequest/OutlinedInput'
import { useTranslation } from 'react-i18next'

type Props = {
  styles: any
  visible: boolean
  actionLoading: boolean
  otherReason: string
  rejectValidationError: string
  onClose: () => void
  onSetOtherReason: (value: string) => void
  onSetRejectValidationError: (value: string) => void
  onRejectSubmit: () => void
  enforceCharacterLimit: (value: string, maxLength?: number) => string
}

const DemoRejectReasonDrawer = ({
  styles,
  visible,
  actionLoading,
  otherReason,
  rejectValidationError,
  onClose,
  onSetOtherReason,
  onSetRejectValidationError,
  onRejectSubmit,
  enforceCharacterLimit,
}: Props) => {
  const { t } = useTranslation()

  if (!visible) return null

  return (
    <BottomDrawer
      visible={visible}
      onClose={onClose}
      closeOnBackdropPress={!actionLoading}
      heading={t('demo_reject_request_heading')}
    >
      <Text style={[TEXT_STYLES.textNeutral90, TYPOGRAPHY.TEXT2]}>
        {t('demo_select_rejection_reason')}
      </Text>
      <Pressable style={styles.reasonRow}>
        <BouncyCheckbox
          isChecked={true}
          useBuiltInState={false}
          onPress={() => null}
          size={20}
          fillColor={COLORS.primary100}
          iconStyle={styles.checkbox}
          innerIconStyle={styles.checkbox}
        />
        <View style={COMMON_STYLES.flex1}>
          <Text style={styles.reasonLabel}>{t('demo_other_specify')}</Text>
        </View>
      </Pressable>
      <View style={styles.reasonInputContainer}>
        <OutlinedInput
          label={t('demo_reason_label')}
          placeholder={t('demo_enter_rejection_reason')}
          multiline
          value={otherReason}
          onChangeText={value => {
            onSetOtherReason(enforceCharacterLimit(value))
            if (value.trim().length > 0) {
              onSetRejectValidationError('')
            }
          }}
        />
      </View>
      {rejectValidationError ? (
        <Text style={styles.validationErrorText}>{rejectValidationError}</Text>
      ) : null}
      <View style={[COMMON_STYLES.row, COMMON_STYLES.mt1, { gap: 12 }]}>
        <Button
          buttonStyle={[BG_STYLES.bgNeutral00, COMMON_STYLES.flex1, styles.modalBtn]}
          type={BUTTON_TYPE.PRIMARY}
          text={t('cancel')}
          onClick={onClose}
          size={SIZE.small}
          status={actionLoading ? BUTTON_STATUS.DISABLED : BUTTON_STATUS.ACTIVE}
          textStyle={[TEXT_STYLES.textNeutral70]}
        />
        <Button
          buttonStyle={[BG_STYLES.bgError100, COMMON_STYLES.flex1, styles.modalBtn]}
          status={actionLoading ? BUTTON_STATUS.DISABLED : BUTTON_STATUS.ACTIVE}
          type={BUTTON_TYPE.PRIMARY}
          text={actionLoading ? t('demo_please_wait') : t('reject')}
          textStyle={[TEXT_STYLES.textNeutral00]}
          onClick={onRejectSubmit}
          size={SIZE.small}
        />
      </View>
    </BottomDrawer>
  )
}

export default DemoRejectReasonDrawer
